module.exports = __webpack_public_path__ + "img/card-reader.27667c64.webp";